export default [
    {
        path: '/system/email-templates',
        name: 'email-templates',
        component: () => import('../../pages/system/EmailTemplatesPage.vue'),
        meta: {
            title: 'Email Templates',
            requiresAuth: true,
        },
    },
]
